import { DatePipe, NgIf } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ConfirmationService, PrimeTemplate } from 'primeng/api';
import { TooltipModule } from 'primeng/tooltip';
import { DrawerModule } from 'primeng/drawer';
import { ToastService } from 'src/app/core/services/toast.service';
import { QrCodeDialogComponent } from 'src/app/shared/components/qr-code-dialog/qr-code-dialog.component';
import { STATES_TO_HIDE_CANCEL_OTP_BUTTON, STATES_TO_HIDE_CONTINUE_OTP_BUTTON, SUBSTATES_TO_REOPEN_BELENDER } from 'src/app/shared/constants/common.constants';
import { UtilsService } from 'src/app/utils/utils.service';
import { LoadingComponent } from '../../../utils/loading/loading.component';
import { NewCardRequestComponent } from '../new-card-request/new-card-request.component';
import { NewCardRequestService } from '../new-card-request/new-card-request.service';
import { CardRequestDetailDocumentsComponent } from './card-request-detail-documents/card-request-detail-documents.component';
import { CardRequestDetailHeaderComponent } from './card-request-detail-header/card-request-detail-header.component';
import { CardRequestDetailService } from './card-request-detail.service';

@Component({
    selector: 'app-card-request-detail',
    templateUrl: './card-request-detail.component.html',
    standalone: true,
    imports: [
        NgIf,
        DrawerModule,
        PrimeTemplate,
        LoadingComponent,
        NewCardRequestComponent,
        CardRequestDetailHeaderComponent,
        CardRequestDetailDocumentsComponent,
        DatePipe,
        TranslateModule,
        RouterOutlet,
        TooltipModule,
        QrCodeDialogComponent
    ]
})
export class CardRequestDetailComponent implements OnInit, OnDestroy {

    items = [];
    newRequestStatus: {
		title: string, step: number, requestLastStatus?: string
	} = { title: 'New request', step: 1 };

    belenderStatus: {
		actualStatus: string;
		actualStatusMessage: string;
	} = { actualStatus: '', actualStatusMessage: '' };
    consentBelenderUrl: SafeResourceUrl;

    isDownloadZipButtonDisabled = false;

    constructor(
		readonly cardRequestDetailService: CardRequestDetailService,
        private readonly toastService: ToastService,
		private readonly sanitizer: DomSanitizer,
		private readonly translate: TranslateService,
		private readonly confirmationService: ConfirmationService,
        readonly newCardRequestService: NewCardRequestService,
        readonly utilsService: UtilsService
    ) { }

    async ngOnInit() {
        await this.cardRequestDetailService.getRequestFromUrl();
        // await this.cardRequestDetailService.getEnrichmentDecission();
    }

    ngOnDestroy(): void {
        // reset the feasibility when the user navigates away from the request detail page
        this.cardRequestDetailService.resetFeasibilityData();
    }

    reopenOTPWidget(): void {
        try {
            this.cardRequestDetailService.isLoading = true;
            this.newRequestStatus = {
                title: "Continuar con el OTP",
                step: 2,
                requestLastStatus: this.cardRequestDetailService.request.personQuery.substatus
            };
            this.belenderStatus = {
                actualStatus: this.cardRequestDetailService.request.personQuery.substatus,
                actualStatusMessage: this.cardRequestDetailService.request.personQuery.substatus
            };

            this.consentBelenderUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.cardRequestDetailService.request.personQuery.consentUrlBoxed);
            this.newCardRequestService.isFinishingOTP = true;
        } catch (e) {
            console.log(e);
            this.toastService.showError(`Error ${e.status} (${e.statusText})`, `${e.error.detail}`, false);
        } finally {
            this.cardRequestDetailService.isLoading = false;
        }
    }

    async cancelOTP(): Promise<void> {
        try {
            this.cardRequestDetailService.isLoading = true;

            const cancelResponse = await this.cardRequestDetailService.cancelRequest({
                queryId: this.cardRequestDetailService.queryId,
                requestReference: undefined,
                userName: undefined,
                userPassword: undefined
            });

            if (cancelResponse.status !== 'Canceled')
                this.toastService.showError('TOAST.ERROR', `${cancelResponse.status}`, false, 10000);
            else {
                this.toastService.showSuccess('TOAST.SUCCESS', 'NEW_REQUEST.CANCEL', true, 10000);
                await this.cardRequestDetailService.getRequestFromUrl(true);
            }
        } catch (e) {
            this.toastService.showError(`Error ${e.error.status} (${e.error.title})`, `${e.error.detail}`, false);
        } finally {
            this.cardRequestDetailService.isLoading = false;
        }
    }

    confirmCancelOTP(event: Event): void {
        if (!event || !event.target) return;

        this.confirmationService.confirm({
            target: event.target,
            message: this.translate.instant('REQUEST_DETAIL.CANCEL_REQUEST_CONFIRMATION'),
            acceptLabel: this.translate.instant('BUTTON.YES'),
            rejectLabel: this.translate.instant('BUTTON.NO'),
            accept: () => {
                this.cancelOTP().catch(error => { console.error(error); });
            }
        });
    }

    verifyRequestCanBeReopened(): boolean {
        const request = this.cardRequestDetailService.request;
        if (!request) return false;

        const status = request.personQuery.status;
        if (status.toLowerCase() !== 'processing') return false;

        const substatus = request.personQuery.substatus;
        return SUBSTATES_TO_REOPEN_BELENDER.includes(substatus);
    }

    hideContinueOTPButton(): boolean {
        const request = this.cardRequestDetailService.request;
        if (!request) return true;

        const status = request.personQuery.status;
        if (STATES_TO_HIDE_CONTINUE_OTP_BUTTON.includes(status)) return true;

        const substatus = request.personQuery.substatus;
        return !SUBSTATES_TO_REOPEN_BELENDER.includes(substatus);
    }

    hideCancelOTPButton(): boolean {
        const request = this.cardRequestDetailService.request;
        if (!request) return true;

        const status = request.personQuery.status;
        return STATES_TO_HIDE_CANCEL_OTP_BUTTON.includes(status);
    }

    // hideDownloadZip(): boolean {
    //     return !this.cardRequestDetailService.request.personQuery.isDocumentsDowloadCompleted;
    // }

    // async downloadZIP(): Promise<void> {
    //     this.isDownloadZipButtonDisabled = true;
    //     const req: FilesRequest = {
    //         detail: this.cardRequestDetailService.request
    //     };
    //     await this.utilsService.downloadZIP(req);
    //     this.isDownloadZipButtonDisabled = false;
    // }
}
